import React from "react";
import PropTypes from "prop-types";
import Popover from "@mui/material/Popover";

const SFPopover = (props) => {
  const handleClose = (e) => {
    props.onClose(e);
  };

  let positions = {
    anchorOrigin: { vertical: "", horizontal: "" },
    transformOrigin: { vertical: "", horizontal: "" },
  };

  if (typeof props.position === "string") {
    switch (props.position) {
    case "top":
    case "top-center":
      positions = {
        anchorOrigin: { vertical: "top", horizontal: "center" },
        transformOrigin: { vertical: "bottom", horizontal: "center" },
      };
      break;
    case "top-left":
      positions = {
        anchorOrigin: { vertical: "top", horizontal: "left" },
        transformOrigin: { vertical: "top", horizontal: "left" },
      };
      break;
    case "top-right":
      positions = {
        anchorOrigin: { vertical: "top", horizontal: "right" },
        transformOrigin: { vertical: "bottom", horizontal: "left" },
      };
      break;
    case "bottom":
    case "bottom-center":
    default:
      positions = {
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        transformOrigin: { vertical: "top", horizontal: "center" },
      };
      break;
    case "bottom-start":
      positions = {
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        transformOrigin: { vertical: "top", horizontal: "left" },
      };
      break;
    case "bottom-left":
      positions = {
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        transformOrigin: { vertical: "top", horizontal: "right" },
      };
      break;
    case "bottom-right":
      positions = {
        anchorOrigin: { vertical: "bottom", horizontal: "right" },
        transformOrigin: { vertical: "top", horizontal: "left" },
      };
      break;
    case "center":
      positions = {
        anchorOrigin: { vertical: "center", horizontal: "center" },
        transformOrigin: { vertical: "center", horizontal: "center" },
      };
      break;
    case "center-right":
      positions = {
        anchorOrigin: { vertical: "center", horizontal: "right" },
        transformOrigin: { vertical: "center", horizontal: "left" },
      };
      break;
    case "center-left":
      positions = {
        anchorOrigin: { vertical: "center", horizontal: "center" },
        transformOrigin: { vertical: "center", horizontal: "right" },
      };
      break;
    }
  }

  const open = Boolean(props.anchorEl);

  if (props.modal) {
    return (
      <Popover
        sx={{
          display: "flex",
          alignContent: "center",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiBackdrop-root": {
            background: "rgba(0,0,0,0.5)",
          },
          "& .MuiPaper-root ": {
            top: "unset !important",
            left: "unset !important",
            ...(props.height && { height: props.height }),
          },
          "& .MuiPopover-paper": {
            boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.25)",
          },
        }}
        open={open}
        anchorEl={props.anchorEl}
        onClose={handleClose}
        className={props.className}
      >
        {props.children}
      </Popover>
    );
  }
  return (
    <Popover
      sx={{
        "& .MuiPopover-paper": {
          boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.25)",
        },
      }}
      open={open}
      anchorEl={props.anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: positions.anchorOrigin.vertical,
        horizontal: positions.anchorOrigin.horizontal,
      }}
      transformOrigin={{
        vertical: positions.transformOrigin.vertical,
        horizontal: positions.transformOrigin.horizontal,
      }}
      {...(props.container && { container: props.container })}
      anchorReference={
        typeof props.position === "string" ? "anchorEl" : "anchorPosition"
      }
      {...(typeof props.position === "object" && {
        anchorPosition: { left: props.position.left, top: props.position.top },
      })}
      className={props.className}
    >
      {props.children}
    </Popover>
  );
};

SFPopover.defaultProps = {
  anchorEl: null,
  position: "center",
};

SFPopover.propTypes = {
  anchorEl: PropTypes.any,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  position: PropTypes.oneOfType([
    PropTypes.oneOf(["top", "bottom", "left", "right"]),
    PropTypes.shape({
      top: PropTypes.number,
      left: PropTypes.number,
    }),
    PropTypes.string,
  ]),
};

export default SFPopover;
